import { ReactNode, useMemo, useState } from 'react';
import { IConversationMessage } from 'src/@types/conversation';

import { ConversationMediaContentView } from '../../ConversationMediaContentView';

import { conversationMediaContext } from './singleton';

const { Provider } = conversationMediaContext;

export const ConversationMediaContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [openMessageMedia, setOpenMessageMedia] =
    useState<IConversationMessage | null>(null);

  const value = useMemo(
    () => ({
      openMessageMedia,
      setOpenMessageMedia,
    }),
    [openMessageMedia],
  );

  return (
    <Provider value={value}>
      {children}
      {openMessageMedia && (
        <ConversationMediaContentView
          message={openMessageMedia}
          onClose={() => setOpenMessageMedia(null)}
        />
      )}
    </Provider>
  );
};
